import { Message } from 'element-ui'
import service from './request'
import { notifyUnauthorized } from './auth'

class BusinessError extends Error {
  constructor(message) {
    super(message)
    this.name = 'BusinessError'
    this.handled = true
  }
}

function isUnauthorizedResponse(res) {
  return res && Number(res.code) === 401
}


export function request(config) {
  return service(config)
    .then((res) => {
      if (isUnauthorizedResponse(res)) {
        notifyUnauthorized()
        throw new BusinessError(res.msg || '请先登录')
      }
      if (res && res.code === 1) {
        return res
      }
      const msg = (res && res.msg) || '请求失败'
      Message.error(msg)
      throw new BusinessError(msg)
    })
    .catch((err) => {
      if (err instanceof BusinessError) {
        return Promise.reject(err)
      }
      if (err && err.response && err.response.status === 401) {
        return Promise.reject(err)
      }
      if (err && typeof err === 'object' && err.code !== undefined && err.code !== 1) {
        const msg = err.msg || '请求失败'
        Message.error(msg)
        return Promise.reject(new BusinessError(msg))
      }
      return Promise.reject(err)
    })
}

export function postForm(url, data) {
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key])
  })
  return request({
    url,
    method: 'post',
    data: formData
  })
}

export function postJson(url, data) {
  return request({
    url,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function get(url, params) {
  return request({
    url,
    method: 'get',
    params
  })
}
